module.exports = __webpack_public_path__ + "static/media/icon_nutrition.1a938dfe.svg";